import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { Box } from '@mui/material';

import { css, keyframes, styled } from '../../Utils/style';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(8px);
  }
`;

export const ScrollIndicator = styled(Box)`
  ${({ theme }) => css`
    position: fixed;
    right: 1rem;
    bottom: ${theme.spacing(3)};
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    background-color: ${theme.palette.primary.main};
    opacity: 0.8;
  `}
`;

export const IndicatorArrows = styled(KeyboardArrowDownIcon)`
  ${({ theme }) => css`
    color: ${theme.palette.layout.main};
    animation: ${bounce} 2s infinite;
  `}
`;
